require('./bootstrap');

require('select2');
require('select2/dist/js/i18n/fr');

import * as Sentry from "@sentry/browser";
import {Integrations} from "@sentry/tracing";
import mixpanel from 'mixpanel-browser';
import { tracking } from './tracking';
import { initTarteaucitron } from './tarteaucitron-init';
import { initAuthModalAjaxForms } from './auth/authModalAjax';
initTarteaucitron();
initAuthModalAjaxForms();

const updateTourGuideStatus = (key, value) => {
    $.post(window.app_base_url + '/profile/tour-guide', {key, value}, function (data) {
        currentUser = data;
    }, 'json');
}

window.updateTourGuideStatus = updateTourGuideStatus;

const root = document.documentElement;
const marqueePlansElementsDisplayed = getComputedStyle(root).getPropertyValue("--marquee-plans-elements-displayed");
const marqueePlansContent = document.querySelector("ul.marquee-plans-content");

if (marqueePlansContent) {
    root.style.setProperty("--marquee-plans-elements", marqueePlansContent.children.length);

    for(let i=0; i<marqueePlansElementsDisplayed; i++) {
        marqueePlansContent.appendChild(marqueePlansContent.children[i].cloneNode(true));
    }
}

if(window.location.hash) {
    const hash = window.location.hash.substring(1);
    if (hash === 'modalBuyProduct') {
        window.location.replace(website.full_url + '/plans');
    }
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has('esource')) {
    const esource = urlParams.get('esource');
    if (esource) {
        fetch(window.location.origin + '/set-source', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({esource: esource})
        })
    }
}

// --- Tracking module wiring (replaces inline Mixpanel block) ---
tracking.init({
    mixpanelInstance: mixpanel,
    mixpanelToken: window.MH_MIXPANEL_TOKEN,
    websiteContext: window.MH_WEBSITE_CONTEXT,
    userContext: window.MH_USER_CONTEXT,
    queuedEvents: window.MH_QUEUED_EVENTS,
});

// Page Viewed (renamed from Page View, dual-fire) — fires immediately.
tracking.pageViewed(detectPageType());

// Product Category Selected (renamed from Product Category Updated).
if (typeof Livewire !== 'undefined') {
    Livewire.on('productCategoryUpdated', (value) => {
        tracking.productCategorySelected(value);
    });
}

// Preserved from old code: hidden distinct_id field on register form.
$(document).on('submit', '#registerForm', function () {
    if (typeof mixpanel === 'undefined' || !mixpanel.get_distinct_id) return;
    const hiddenInput = $(this).find("input[name='distinct_id']");
    if (hiddenInput[0]) hiddenInput[0].value = mixpanel.get_distinct_id();
});

function detectPageType() {
    const path = window.location.pathname;
    if (path === '/' || path.match(/^\/[a-z]{2}\/?$/)) return 'home';
    if (path.includes('/map/')) return 'map';
    if (path.includes('/plans')) return 'plans';
    if (path.includes('/product')) return 'product';
    if (path.includes('/checkout') || path.includes('/payment')) return 'checkout';
    if (path.includes('/landing/') || path.includes('-pass')) return 'landing';
    return 'static';
}

if (typeof sentryDns !== 'undefined' && sentryDns) {
    Sentry.init({
        dsn: sentryDns,
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });

    if (typeof sentryUserId !== 'undefined') {
        Sentry.setUser({email: sentryUserId});
    }
}

function select2(size) {
    $("select:not('.native-select')").each(function () {
        $(this).select2({
            language: website.fallback_locale || 'fr',
            theme: "bootstrap-5",
            width: $(this).data("width") ? $(this).data("width") : $(this).hasClass("w-100") ? "100%" : "style",
            placeholder: $(this).data("placeholder"),
            maximumSelectionLength: $(this).data("maximumSelectionLength") ? $(this).data("maximumSelectionLength") : 0,
            allowClear: Boolean($(this).data("allow-clear")),
            closeOnSelect: !$(this).attr("multiple"),
            containerCssClass: size == "small" || size == "large" ? "select2--" + size : "",
            selectionCssClass: size == "small" || size == "large" ? "select2--" + size : "",
            dropdownCssClass: size == "small" || size == "large" ? "select2--" + size : "",
        });
    });
}

select2('small');

$(`[data-dependency-name]`).on('change', function () {
    reloadFields();
});

function reloadFields() {
    $('[data-dependencies]').each(function () {
        if ($(this).data('dependencies')) {
            Object.entries($(this).data('dependencies')).forEach(([name, values]) => {
                if (!$(`[data-dependency-name=${name}]`).val() || values.indexOf($(`[data-dependency-name=${name}]`).val()) !== -1) {
                    $(this).prop("disabled", false);
                } else {
                    $(this).prop("disabled", true);
                }
            });
        }
    });
}

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

//tab deep linking
var url = window.location.href;
if (url.indexOf("#") > 0) {
    var activeTab = url.substring(url.indexOf("#") + 1);
    if (activeTab) {
        if ($(`.modal#${activeTab}`).length > 0) {
            (new bootstrap.Modal(document.getElementById(activeTab))).show();
        }
        if (document.querySelector('.nav[role="tablist"] a[href="#' + activeTab + '"]')) {
            (new bootstrap.Tab(document.querySelector('.nav[role="tablist"] a[href="#' + activeTab + '"]'))).show();
        }
    }
}

$('a[role="tab"]').on("click", function () {
    var newUrl;
    const hash = $(this).attr("href");
    newUrl = url.split("#")[0] + hash;
    history.replaceState(null, null, newUrl);
});

(function ($) {
    $.fn.loadingButton = function (action) {
        if (this.length > 0) {
            this.each(function () {
                if (action === 'loading' && $(this).data('loading-text')) {
                    $(this).data('original-text', $(this).html()).html($(this).data('loading-text')).prop('disabled', true);
                } else if (action === 'reset' && $(this).data('original-text')) {
                    $(this).html($(this).data('original-text')).prop('disabled', false);
                }
            });
        }
    };
}(jQuery));

/**
 * Listen to scroll to change header opacity class
 */
function checkScroll() {
    var startY = $('.navbar').height() * 2; //The point where the navbar changes in px

    if ($(window).scrollTop() > startY) {
        $('.navbar').addClass("scrolled");
    } else {
        $('.navbar').removeClass("scrolled");
    }
}

if ($('.navbar').length > 0) {
    $(window).on("scroll load resize", function () {
        checkScroll();
    });
}

// var modalBuyProduct = document.getElementById('modalBuyProduct')
// modalBuyProduct.addEventListener('shown.bs.modal', function (event) {
//     if (typeof mixpanelToken !== 'undefined' && mixpanelToken) {
//         mixpanel.track('Modal Buy Product Shown');
//     }
//
//     $('.modal-backdrop').addClass('modal-backdrop-map');
//     $('.modal-backdrop').addClass(`modal-backdrop-map-${website.country.iso_3166_2.toLowerCase()}`);
// });

$(document).ready(function () {
    fetch(window.app_base_url + '/csrf', {
        method: 'POST',
    })
        .then(async function (response) {
            if (response.status === 200) {
                const { token } = await response.json();
                if (document.querySelector('meta[name="csrf-token"]')) {
                    document.querySelector('meta[name="csrf-token"]').setAttribute('content', token);
                }

                if (document.querySelector('input[name="_token"]')) {
                    document.querySelector('input[name="_token"]').setAttribute('value', token);
                }

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                });
            } else {
                console.log('CSRF Error Occurred');
            }
        })
        .catch(function (err) {
            console.log(err)
            console.log('Error Occurred');
        });

    if ($('.payment-form').length > 0) {
        $('.payment-form').on('submit', async function (e) {
            $('.btn', this).loadingButton('loading');
            e.preventDefault();
            if ($('.stripe-form-create').is(':visible')) {
                const {success} = await submitPaymentMethod($('.stripe-form-create'));
                if (success) {
                    e.currentTarget.submit();
                }
            } else {
                e.currentTarget.submit();
            }
        });
    }

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
});

/**
 * Saves the payment method for the user and re-loads the payment methods.
 */
const savePaymentMethod = async (method) => {
    const {data} = await axios.post('/user/payment-methods', {
        payment_method: method
    });
    return data;
};

const submitPaymentMethod = async (form) => {
    if ($('[name=name]', form).val() === '') {
        $('[name=name]', form).addClass('form-error').next('.invalid-feedback').html('Ce champ est obligatoire').show();
        return {success: false, error: 'empty_name'};
    } else {
        $('[name=name]', form).removeClass('form-error').next('.invalid-feedback').html('').hide();
    }

    let addPaymentStatus = 1;

    const result = await stripe.confirmCardSetup(
        intentClientSecret, {
            payment_method: {
                card: cardNumberElement,
                billing_details: {
                    name: $('[name=name]', form).val(),
                    email: $('[name=email]', form).val(),
                    address: {
                        line1: $('[name=address]', form).val(),
                        postal_code: $('[name=postal_code]', form).val(),
                        country: $('[name=country]', form).val(),
                    }
                }
            }
        }
    );

    if (result.error) {
        addPaymentStatus = 3;
        const addPaymentStatusError = result.error.message;
        return {success: false, error: result.error, setupIntent: null};
    } else {
        stripeTokenHandler(result.setupIntent.payment_method, form);
        return {success: true, setupIntent: result.setupIntent};
    }
}

// Submit the form with the token.
function stripeTokenHandler(token, form) {
    // Insert the token ID into the form so it gets submitted to the server
    if ($('.payment-form').find('[name=stripeToken]').length > 0) {
        $('.payment-form').find('[name=stripeToken]').val(token);
    } else {
        var hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', 'stripeToken');
        hiddenInput.setAttribute('value', token);
        $('.payment-form').append(hiddenInput);
    }
}

/**
 * Build payment methods HTML
 */
const buildStripeForm = () => {
    const isCreate = $('.stripe-form-create').is(':visible');

    if (isCreate) {
        $('.js-payment-no-method').removeClass('d-none').addClass('d-block');
        $('.js-payment-has-method').removeClass('d-block').addClass('d-none');
        cardNumberElement.mount('#stripe-card-number-create');
        cardExpiryElement.mount('#stripe-card-expiry-create');
        cardCvcElement.mount('#stripe-card-cvc-create');
    } else {
        cardNumberElement.unmount('#stripe-card-number-create');
        cardExpiryElement.unmount('#stripe-card-expiry-create');
        cardCvcElement.unmount('#stripe-card-cvc-create');
        cardNumberElement.mount('#stripe-card-number-update');
        cardExpiryElement.mount('#stripe-card-expiry-update');
        cardCvcElement.mount('#stripe-card-cvc-update');
    }
}

$(document).ready(function () {
    if (typeof cardNumberElement !== 'undefined') {
        buildStripeForm();
    }

    if (typeof lastPaymentMethod !== 'undefined') {
        setCardData(lastPaymentMethod);
    }
});

$('.stripe-form-update').on('submit', async function (e) {
    $('.btn', this).loadingButton('loading');
    e.preventDefault();
    const {success, error, setupIntent} = await submitPaymentMethod($('.stripe-form-update'));
    if (success) {
        const card = await savePaymentMethod(setupIntent.payment_method);
        setCardData(card);
        const modalUpdatePaymentMethod = document.getElementById('modalUpdatePaymentMethod');
        resetStripeForm($('.stripe-form-update'));
        bootstrap.Modal.getInstance(modalUpdatePaymentMethod).hide();
        $('.btn', this).loadingButton('reset');
    } else {
        console.log(error)
        $('.btn', this).loadingButton('reset');
    }
});

const resetStripeForm = (form) => {
    form[0].reset();
    cardNumberElement.unmount('#stripe-card-number-create');
    cardExpiryElement.unmount('#stripe-card-expiry-create');
    cardCvcElement.unmount('#stripe-card-cvc-create');
    cardNumberElement.unmount('#stripe-card-number-update');
    cardExpiryElement.unmount('#stripe-card-expiry-update');
    cardCvcElement.unmount('#stripe-card-cvc-update');
    cardNumberElement.mount('#stripe-card-number-update');
    cardExpiryElement.mount('#stripe-card-expiry-update');
    cardCvcElement.mount('#stripe-card-cvc-update');
    // Remove button to update payment method because we need to get a new intent
    // @todo get intent with ajax request
    $('.js-method-payment-update').hide();
}

/** fix height with bottom bar on android & iphone (Fix hidden cart validate button) */
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
